<!-- Modal Template for Desktop -->
<ng-template #modalTemplate let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modalTitle }}</h5>
    <button (click)="modal.dismiss()" class="btn-close" aria-label="Close" type="button"></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-body">
      <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
    </div>

    <div class="modal-footer">
      <button [disabled]="submitting" (click)="modal.dismiss()" class="btn btn-secondary" type="button">
        {{ "Cancel" | translate }}
      </button>
      <button [disabled]="!form.valid || submitting" class="btn btn-danger" type="submit">
        <ng-container *ngIf="!submitting; else submittingText">
          <fa-icon class="me-1" icon="flag"></fa-icon>
          {{ "Submit Report" | translate }}
        </ng-container>
        <ng-template #submittingText>
          <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" role="status"></span>
          {{ "Submitting..." | translate }}
        </ng-template>
      </button>
    </div>
  </form>
</ng-template>

<!-- Offcanvas Template for Mobile -->
<ng-template #offcanvasTemplate let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">{{ modalTitle }}</h5>
    <button (click)="offcanvas.dismiss()" class="btn-close" aria-label="Close" type="button"></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="offcanvas-body">
      <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>

      <div class="d-grid gap-2">
        <button [disabled]="!form.valid || submitting" class="btn btn-danger" type="submit">
          <ng-container *ngIf="!submitting; else submittingTextMobile">
            <fa-icon class="me-1" icon="flag"></fa-icon>
            {{ "Submit Report" | translate }}
          </ng-container>
          <ng-template #submittingTextMobile>
            <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" role="status"></span>
            {{ "Submitting..." | translate }}
          </ng-template>
        </button>
        <button [disabled]="submitting" (click)="offcanvas.dismiss()" class="btn btn-secondary" type="button">
          {{ "Cancel" | translate }}
        </button>
      </div>
    </div>
  </form>
</ng-template>
